import { Component } from '@angular/core';
import { TrustboxComponent } from '../../../../_components/trustbox/trustbox.component';

@Component({
    selector: 'app-easter-reviews',
    imports: [TrustboxComponent],
    template: `
    <div class="tw-w-full tw-bg-v4-grey-2 tw-py-10 md:tw-py-16 tw-px-5 md:tw-px-10 gradient-shadow-combined">
        <div class="tw-flex tw-flex-col md:tw-flex-row tw-items-center tw-justify-center tw-gap-6 md:tw-gap-16 lg:tw-gap-20">
            <h2 class="section-title tw-text-2xl md:tw-text-4xl 2xl:tw-text-[2.5rem] !tw-font-normal tw-mb-0 tw-text-center md:tw-text-left" style="font-family: 'Montserrat', 'Poppins', 'Open Sans', sans-serif;">
                <span class="tw-font-black" style="-webkit-text-stroke: 1px currentColor;">4,500+ VERIFIED REVIEWS</span> <br/>
                ACROSS PLATFORMS
            </h2>
            <div class="tw-flex tw-flex-row tw-items-center tw-justify-center tw-gap-6 md:tw-gap-10">
                <img decoding="async" src="https://nustone-bucket.s3.eu-west-2.amazonaws.com/assets/trustpilot.svg" alt="Trustpilot reviews" class="tw-h-12 md:tw-h-20 lg:tw-h-24"/>
                <div class="elfsight-app-3dd25230-f43e-47b4-a8f9-fe923ec97d97 tw-scale-90 md:tw-scale-125 lg:tw-scale-150 tw-ml-6 md:tw-ml-10" data-elfsight-app-lazy></div>
            </div>
        </div>
    </div>
  `
})
export class EasterReviewsComponent {}
